module.exports = __webpack_public_path__ + "123ab628.png";